/////////////////////////////////////////////////////////////////////////////////////
////////////// DeleteWikiPageModal //////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import MaterialModal from "../MaterialModal";
import { DeleteWikiPage } from "../../../actions/wikiActions";
import { hideModal } from "../../../actions/actionCreators";
import withModal from "../withModal";

const DeleteWikiPageModal = ({ isOpen, modalProps }) => {
    const dispatch = useDispatch();

    const hide = () => {
        dispatch(hideModal("WIKI_DELETE"));
    };

    const deletePage = () => {
        dispatch(DeleteWikiPage(modalProps.id));
        hide();
    };

    const modalText = (
        <span style={{ fontSize: "1.75em" }}>
            Are you sure you want to <strong className="text-danger">delete</strong> this page?
            <br />
            <strong className="text-danger">
                This action is permanent, the page cannot be recovered after deletion.
            </strong>
        </span>
    );

    return (
        <MaterialModal
            title="Delete Page"
            isOpen={isOpen}
            onClose={hide}
            id="wiki-delete"
            onPrimaryButtonRequest={deletePage}
            primaryButtonText={"Delete"}
        >
            {modalText}
        </MaterialModal>
    );
};

DeleteWikiPageModal.propTypes = {
    // Injected from Redux
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
};

export default withModal(DeleteWikiPageModal, "WIKI_DELETE");
